// extracted by mini-css-extract-plugin
export default {"light":"styles_light__vCK7C","menu":"styles_menu__qqPt1","navLink":"styles_navLink__oIejr"};